import React, { Fragment } from 'react'
import defaultClasses from './html.module.scss'
import { compactInlineStyles } from '../../utils'
import { mergeClasses } from '../../classify'
import { arrayOf, shape, string } from 'prop-types'
import { useAnchorNavigation } from '../../useAnchorNavigation'
import PageBuilderStyleTags from '../../PageBuilderStyleTags'
import { prepareCmsMediaHtml } from '../../applyInlineMobileVideoPlayback'

const toHTML = (str) => ({ __html: str })

const Html = (props) => {
    const classes = mergeClasses(defaultClasses, props.classes)
    const {
        html,
        cssBlocks = [],
        textAlign,
        border,
        borderColor,
        borderWidth,
        borderRadius,
        marginTop,
        marginRight,
        marginBottom,
        marginLeft,
        paddingTop,
        paddingRight,
        paddingBottom,
        paddingLeft,
        cssClasses = []
    } = props

    const dynamicStyles = {
        textAlign,
        border,
        borderColor,
        borderWidth,
        borderRadius,
        marginTop,
        marginRight,
        marginBottom,
        marginLeft,
        paddingTop,
        paddingRight,
        paddingBottom,
        paddingLeft
    }

    const preparedHtml = prepareCmsMediaHtml(html)
    const divRef = useAnchorNavigation(preparedHtml)

    return (
        <>
            {/* eslint-disable-next-line i18next/no-literal-string */}
            <PageBuilderStyleTags cssBlocks={cssBlocks} idPrefix="pb-html" />
            {preparedHtml ? (
                <div
                    ref={divRef}
                    style={compactInlineStyles(dynamicStyles)}
                    className={[classes.root, ...cssClasses].join(' ')}
                    dangerouslySetInnerHTML={toHTML(preparedHtml)}
                />
            ) : null}
        </>
    )
}

Html.propTypes = {
    classes: shape({
        root: string
    }),
    html: string,
    cssBlocks: arrayOf(string),
    textAlign: string,
    border: string,
    borderColor: string,
    borderWidth: string,
    borderRadius: string,
    marginTop: string,
    marginRight: string,
    marginBottom: string,
    marginLeft: string,
    paddingTop: string,
    paddingRight: string,
    paddingBottom: string,
    cssClasses: arrayOf(string)
}

export default Html
